var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.6662 9.3332H5.33287V13.9999C5.33287 14.1767 5.4031 14.3463 5.52813 14.4713C5.65315 14.5963 5.82272 14.6665 5.99953 14.6665H9.99953C10.1763 14.6665 10.3459 14.5963 10.4709 14.4713C10.596 14.3463 10.6662 14.1767 10.6662 13.9999V9.3332H13.3329C13.4584 9.33299 13.5813 9.29738 13.6875 9.23048C13.7937 9.16357 13.8788 9.06807 13.9332 8.95495C13.9876 8.84182 14.0089 8.71566 13.9948 8.59094C13.9808 8.46623 13.9318 8.34801 13.8535 8.24987L8.5202 1.5832C8.2662 1.26654 7.73286 1.26654 7.47887 1.5832L2.14553 8.24987C2.06729 8.34801 2.01831 8.46623 2.00422 8.59094C1.99013 8.71566 2.01149 8.84182 2.06586 8.95495C2.12023 9.06807 2.2054 9.16357 2.31159 9.23048C2.41778 9.29738 2.54069 9.33299 2.6662 9.3332Z",
    fill: "#FCD559"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: -2,
    y: -2.6543,
    width: 19.9991,
    height: 21.3208,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.937255 0 0 0 0 0.768627 0 0 0 0 0.290196 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowUp);
export default __webpack_public_path__ + "static/media/icon-arrow-up.d8ada4c4c8fc90f0164010436ea4206a.svg";
export { ForwardRef as ReactComponent };